import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { PrinterOutlined } from "@ant-design/icons";

const Print = ({
  id = "btn-print",
  title,
  icon = <PrinterOutlined />,
  type = "default",
  onClick = () => {},
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.print");
  return (
    <Button
      className="flex items-center justify-center"
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Print);
